import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GoogleAnalytics2 = forwardRef<SVGSVGElement, IconProps>(({ color = 'white', size = 20 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="3" fill="url(#paint0_linear_4027_240)" />
      <g clipPath="url(#clip0_4027_240)">
        <path
          d="M17.0005 15.9919C17.0005 17.0803 16.1442 17.9981 15.0901 17.9981H14.8588C13.8707 17.8622 13.146 16.944 13.1791 15.9239V4.09004C13.146 3.06974 13.8707 2.18528 14.8588 2.0157C15.9129 1.88051 16.8681 2.66179 17.0005 3.74979V15.9919Z"
          fill={color}
        />
        <path
          d="M4.9113 14.0532C5.28914 14.0532 5.6585 14.1689 5.97267 14.3856C6.28683 14.6023 6.53169 14.9103 6.67629 15.2707C6.82088 15.6311 6.85872 16.0277 6.785 16.4102C6.71129 16.7928 6.52934 17.1442 6.26216 17.4201C5.99499 17.6959 5.65458 17.8837 5.284 17.9598C4.91342 18.0359 4.5293 17.9969 4.18021 17.8476C3.83113 17.6983 3.53277 17.4455 3.32285 17.1212C3.11293 16.7969 3.00088 16.4155 3.00088 16.0255C2.96799 14.9373 3.8572 14.0532 4.9113 14.0532ZM9.95091 8.03418C8.8966 8.10232 8.07423 9.0203 8.07423 10.1085V15.4475C8.07423 16.8755 8.70007 17.7598 9.58928 17.9638C10.6436 18.1679 11.6317 17.4877 11.8622 16.3995C11.8951 16.2636 11.8951 16.1276 11.8951 15.9915V10.0406C11.8951 8.95217 11.0387 8.03418 9.98465 8.03418H9.95091Z"
          fill={color}
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_4027_240" x1="10" y1="20" x2="10" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E37400" />
          <stop offset="1" stopColor="#F9AB00" />
        </linearGradient>
        <clipPath id="clip0_4027_240">
          <rect width="14" height="16" fill="white" transform="translate(3 2)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default GoogleAnalytics2
